const isIOS = () => /iP(ad|hone|od)/.test(navigator.userAgent) || (navigator.userAgent.includes("Macintosh") && navigator.maxTouchPoints > 1);

const canScrollDown = (el: Element | null) => {
  for (let n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
    const oy = getComputedStyle(n).overflowY;
    if ((oy === "auto" || oy === "scroll") && n.scrollHeight > n.clientHeight + 1) return n.scrollTop + n.clientHeight < n.scrollHeight - 1;
  }
  return false;
};

const atPageBottom = () => {
  const vv = window.visualViewport;
  return (vv ? vv.pageTop + vv.height : window.scrollY + window.innerHeight) >= document.documentElement.scrollHeight - 1;
};

// iPad/iPhone ignore overscroll-behavior on the page itself, so stop the pull past the footer by hand.
export function stopBottomBounce() {
  if (!isIOS()) return;
  let x = 0, y = 0;
  document.addEventListener("touchstart", (e) => { if (e.touches.length === 1) { x = e.touches[0].clientX; y = e.touches[0].clientY; } }, { passive: true });
  document.addEventListener("touchmove", (e) => {
    if (e.touches.length !== 1) return;
    const t = e.touches[0], dx = t.clientX - x, dy = t.clientY - y;
    x = t.clientX; y = t.clientY;
    if (!e.cancelable || dy >= 0 || Math.abs(dx) > Math.abs(dy)) return;
    if (atPageBottom() && !canScrollDown(e.target as Element)) e.preventDefault();
  }, { passive: false });
}
